/**
 * Checklist Structure
 * 'productName-pageName': {
 *      modelName: ['id1', 'id2', ...];
 * }
 *
 *  */

export const getStorageKey = (productName, pageName, pageOpt = '') => {
  return `${productName}-${pageName}${pageOpt}`;
};

export const setLocalStorageChecklist = ({
  productName,
  pageName,
  arrayModel,
  pageOpt,
  checklist,
}) => {
  const key = getStorageKey(productName, pageName, pageOpt);
  const checkedIdObj = JSON.parse(localStorage.getItem(key)) || {};
  const currentCheckedIds = checklist.reduce((ids, item) => {
    if (item.done) {
      ids.push(item.id);
    }
    return ids;
  }, []);
  checkedIdObj[arrayModel] = currentCheckedIds;
  localStorage.setItem(key, JSON.stringify(checkedIdObj));
};
export const getLocalStorageChecklist = ({
  productName,
  pageName,
  pageOpt,
  arrayModel,
}) => {
  const key = getStorageKey(productName, pageName, pageOpt);
  const checkedIdObj = JSON.parse(localStorage.getItem(key));
  return checkedIdObj && typeof checkedIdObj[arrayModel] !== 'undefined'
    ? checkedIdObj[arrayModel]
    : [];
};
